import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DispatchDefinitions } from '../../services/Ebootis.Queries/DispatchDefinitions';
import { OrderDetailsByOid } from '../../services/Ebootis.Queries/OrderDetailsByOid';
import { OrderStates } from '../../services/Ebootis.Queries/OrderStates';
import { OrdersOfLogonUser } from '../../services/Ebootis.Queries/OrdersOfLogonUser';
import { IZbsApp } from '../../services/Ebootis.ServiceProxies/IZbsApp';

@Injectable({
	providedIn: 'root'
})
export class OrderService {

	constructor(
		private m_dispatchDefinitions: DispatchDefinitions,
		private m_orderDetailsByOid: OrderDetailsByOid,
		private m_ordersOfLogonUser: OrdersOfLogonUser,
		private m_orderStates: OrderStates,
		private m_zbsApp: IZbsApp
	) { }

	/**
	 * Liefert das Ergebnis des Queries für OrderStates zurück.
	 */
	public getOrderStates(): Observable<OrderStates.Result[]> {
		return this.m_orderStates.query();
	}

	/**
	 * Liefert das Ergebnis des Queries für OrdersOfLogonUser zurück.
	 * @param p_params Parameter für OrdersOfLogonUser
	 */
	public searchOrders(p_params: OrdersOfLogonUser.Params): Observable<OrdersOfLogonUser.Result[]> {
		return this.m_ordersOfLogonUser.query(p_params);
	}

	/**
	 * Liefert das Ergebnis des Queries für OrderDetailsByOid zurück.
	 * @param p_params Parameter für OrderDetailsByOid
	 */
	public getOrderDetailsByOid(p_params: OrderDetailsByOid.Params): Observable<OrderDetailsByOid.Result> {
		return this.m_orderDetailsByOid.query(p_params);
	}

	/**
	 * Liefert das Ergebnis des Queries für DispatchDefinitions zurück.
	 * @param p_params Parameter für DispatchDefinitions
	 */
	public getDispatchDefinitions(p_params: DispatchDefinitions.Params): Observable<DispatchDefinitions.Result[]> {
		return this.m_dispatchDefinitions.query(p_params);
	}

	/**
	 * Liefert das Ergebnis der ServiceMethode für saveOrder zurück.
	 * @param p_order IZbsApp.Order
	 */
	public saveOrder(p_order: IZbsApp.Order): Observable<any> {
		return this.m_zbsApp.saveOrder(p_order);
	}

	public authorizeOrder(p_params: IZbsApp.AuthorizeOrderParms): Observable<any> {
		return this.m_zbsApp.authorizeOrder(p_params);
	}
}
